<template>
  <div class="statistics">
    <tabsLayout>
      <b-tabs
        active-nav-item-class="font-weight-bold"
        content-class="my-0"
        card
        lazy
        :value="currentTabIndex"
      >
        <b-tab
          v-for="tab of tabs"
          :key="tab.key"
          :title="tab.label"
          @click="routerTo(tab)"
          class="px-0"
        />
      </b-tabs>
      <listLayout>
        <router-view></router-view>
      </listLayout>
    </tabsLayout>
  </div>
</template>

<script>
import tabsLayout from "@/layout/TabsLayout.vue";
import listLayout from "@/layout/ListLayout.vue";

export default {
  components: {
    tabsLayout,
    listLayout
  },
  data() {
    return {
      tabs: [
        {
          key: "price-to-earning-ratio",
          label: "本益比"
        },
        {
          key: "income",
          label: "收益統計"
        }
      ],
      currentTabIndex: 0
    };
  },
  methods: {
    routerTo(tab) {
      this.$router.push({ name: tab.key });
    }
  }
};
</script>

<style lang="scss" scoped></style>
